import { render, staticRenderFns } from "./pageinfo.vue?vue&type=template&id=47cc046a&scoped=true&"
import script from "./pageinfo.vue?vue&type=script&lang=js&"
export * from "./pageinfo.vue?vue&type=script&lang=js&"
import style0 from "./pageinfo.vue?vue&type=style&index=0&id=47cc046a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cc046a",
  null
  
)

export default component.exports